import { Button, Typography } from "@mui/material";
import { useAccountStore } from "../common/account";

export function MainMenuInactivity() {
    const { inactivityRemainingMinutes } = useAccountStore(p => ({
        inactivityRemainingMinutes: p.inactivityRemainingMinutes,
    }));
    return <>
        {inactivityRemainingMinutes != null && <>
            <Typography variant="body2" color="inherit">Auto-logout in {Math.round(inactivityRemainingMinutes)} min</Typography>
            <Button style={{ marginLeft: 5 }} onClick={() => {
                useAccountStore.getState().refreshAccessToken(true);
                useAccountStore.getState().resetInactivityTimer();
            }} color="positive">Stay logged in</Button>
        </>}
    </>;
}
